import React from "react";
import PropTypes from "prop-types";
import {FormValidation} from "calidation";
import MetadataEditForm from "./MetadataEditForm";
import MetadataRow from "./MetadataRow";
import {metadataInitialState} from "./metadataInitialState";
import {createErrorList, hasErrors} from "../form/createErrorList";
import * as buttonConstants from "../buttons/buttonConstants";
import Button from "../buttons/button";

class MetadataList extends React.PureComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            isEditing: false,
            editingRowIndex: 0,
            addRowIndex: -1,
            resetSubmittedCount: 0
        };

        this.onAddMetadata = this.onAddMetadata.bind(this);
        this.onEditMetadata = this.onEditMetadata.bind(this);
        this.onEditMetadataSubmit = this.onEditMetadataSubmit.bind(this);
        this.onEditMetadataCancel = this.onEditMetadataCancel.bind(this);
        this.onDeleteMetadata = this.onDeleteMetadata.bind(this);
    }

    setEditingState(nextState) {
        this.setState(nextState, () => {
            if (this.props.onEditingChange) {
                this.props.onEditingChange(this.state.isEditing);
            }
        });
    }

    isKeyUnique(newKey) {
        let keyUnique = true;
        for (let i = 0; i < this.props.metadata.length && keyUnique; i++) {
            if (i !== this.state.editingRowIndex) {
                keyUnique = (this.props.metadata[i].Key !== newKey);
            }
        }
        return keyUnique;
    }

    onAddMetadata(event, setField) {
        event.preventDefault();

        const newIndex = this.props.metadata.length;
        const initial = metadataInitialState();
        initial.Order = newIndex + 1;

        const allMetadata = [...this.props.metadata, initial];
        this.props.onChange(allMetadata);

        this.setEditingState({
            isEditing: true,
            editingRowIndex: newIndex,
            addRowIndex: newIndex,
            resetSubmittedCount: this.state.resetSubmittedCount + 1
        });

        setField({Id: initial.Id, Key: initial.Key, Value: initial.Value});
    }

    onEditMetadata(event, metadata, setField, index) {
        event.preventDefault();
        setField({Id: metadata.Id, Key: metadata.Key, Value: metadata.Value});
        this.setEditingState({isEditing: true, editingRowIndex: index, addRowIndex: -1});
    }

    onEditMetadataSubmit({fields, isValid}) {
        if (!isValid) return;

        let detachedFields = Object.assign({}, fields);
        if (detachedFields.Id === "") detachedFields.Id = 0;

        if (!this.isKeyUnique(detachedFields.Key)) {
            if (this.props.onKeyNotUnique) this.props.onKeyNotUnique(detachedFields.Key);
            return;
        }

        const existing = this.props.metadata[this.state.editingRowIndex];
        const updated = Object.assign({}, existing, {
            Id: detachedFields.Id,
            Key: detachedFields.Key,
            Value: detachedFields.Value
        });

        const allMetadata = this.props.metadata.map((m, i) => (i === this.state.editingRowIndex ? updated : m));
        this.props.onChange(allMetadata);

        this.setEditingState({isEditing: false, editingRowIndex: 0, addRowIndex: -1});
    }

    onEditMetadataCancel(event) {
        event.preventDefault();

        if (this.state.addRowIndex >= 0) {
            const allMetadata = [...this.props.metadata];
            allMetadata.splice(this.state.addRowIndex, 1);
            this.props.onChange(allMetadata);
        }

        this.setEditingState({
            isEditing: false,
            editingRowIndex: 0,
            addRowIndex: -1,
            resetSubmittedCount: this.state.resetSubmittedCount + 1
        });
    }

    onDeleteMetadata(event, index) {
        event.preventDefault();
        if (this.state.addRowIndex >= 0 || confirm("Are you sure you want to delete this metadata entry?\n\nPress \"Ok\" to continue or \"Cancel\" to return to the page.")) {
            const allMetadata = [...this.props.metadata];
            allMetadata.splice(index, 1);
            this.props.onChange(allMetadata);

            this.setEditingState({isEditing: false, editingRowIndex: 0, addRowIndex: -1});
        }
    }

    render() {
        const numberOfColumns = "3";

        const metadataConfig = {
            Key: {isRequired: 'Metadata key is required!'},
            Value: {isRequired: 'Metadata value is required!'},
            Id: {}
        };

        return (
            <FormValidation key={this.state.resetSubmittedCount} onSubmit={this.onEditMetadataSubmit} config={metadataConfig} id={"metadataForm"}>
                {({fields, errors, submitted, setField}) => (
                    <div>
                        <div className={"grid-x"}>
                            <div className={"cell auto"}>
                                <h2>Metadata</h2>
                            </div>
                            <div className={"cell text-right medium-4 large-4"}>
                                <Button config={{
                                    disabled: this.state.isEditing,
                                    name: "btnAddMetadata",
                                    label: "Add Field",
                                    onClick: (event) => this.onAddMetadata(event, setField),
                                    btnClass: "secondary",
                                    btnType: buttonConstants.BUTTON_TYPE_BUTTON
                                }}/>
                            </div>
                        </div>
                        {submitted && hasErrors(errors) &&
                        <div className="text-danger">
                            <p>Please correct the issues as specified.</p>
                            {createErrorList(errors)}
                        </div>
                        }
                        <table className="table-grid hover stack">
                            <thead>
                            <tr>
                                <th className="text-left">Key</th>
                                <th className="text-left">Value</th>
                                <th>Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.props.metadata.map((metadata, index) => {
                                if (this.state.isEditing && index === this.state.editingRowIndex) {
                                    return (<MetadataEditForm key={index} config={{
                                        metadata: metadata,
                                        fields: fields,
                                        submitted: submitted,
                                        errors: errors,
                                        onEditMetadataCancel: this.onEditMetadataCancel
                                    }}/>);
                                }
                                return (<MetadataRow
                                    key={index}
                                    metadata={metadata}
                                    isEditing={this.state.isEditing}
                                    onEditMetadata={(event) => this.onEditMetadata(event, metadata, setField, index)}
                                    onDeleteMetadata={(event) => this.onDeleteMetadata(event, index)}/>);
                            })}
                            {this.props.metadata.length === 0 &&
                            <tr>
                                <td colSpan={numberOfColumns}>
                                    Click &quot;Add Field&quot; to add metadata.
                                </td>
                            </tr>
                            }
                            </tbody>
                        </table>
                    </div>
                )}
            </FormValidation>
        );
    }
}

MetadataList.propTypes = {
    metadata: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
    onEditingChange: PropTypes.func,
    onKeyNotUnique: PropTypes.func
};

export default MetadataList;
